export const HtmlAllowedAttrs = [
  'title', 'href', 'alt', 'src', 'style', 'complete', 'class', 'id', 'controls',
  'origin', 'blob', 'type', 'data-.*'
]
